import {
  ToggleButton,
  ToggleButtonGroup,
  toggleButtonGroupClasses,
} from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

import { ChartViewEnum } from "~/feature/chart/types";

export const Group = styled(ToggleButtonGroup)(({ theme }) => ({
  gap: theme.spacing(1),
  flexWrap: "wrap",

  [`& .${toggleButtonGroupClasses.grouped}`]: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    marginLeft: 0,
  },
}));

export const Button = styled(ToggleButton, {
  shouldForwardProp: (prop) => prop !== "$disabled",
})<{ $disabled?: boolean }>(({ $disabled, theme }) => ({
  textTransform: "none",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(0.75, 1.5, 0.75, 1),
  gap: theme.spacing(0.5),
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1,
  color: theme.palette.text.secondary,

  [`&[data-view="${ChartViewEnum.BOTH}"]`]: {
    paddingLeft: theme.spacing(1.5),
  },

  "& .MuiSvgIcon-root": {
    fontSize: 14,
  },

  ...($disabled && {
    color: theme.palette.text.disabled,
    borderColor: theme.palette.divider,

    "&:hover": {
      backgroundColor: "transparent",
    },
  }),

  "&.Mui-selected": {
    [`&[data-view="${ChartViewEnum.YES}"]`]: {
      color: theme.palette.success.main,
      borderColor: theme.palette.success.main,
      backgroundColor: alpha(theme.palette.success.main, 0.16),

      "&:hover": {
        backgroundColor: alpha(theme.palette.success.main, 0.16),
      },
    },
    [`&[data-view="${ChartViewEnum.NO}"]`]: {
      color: theme.palette.error.main,
      borderColor: theme.palette.error.main,
      backgroundColor: alpha(theme.palette.error.main, 0.16),

      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.16),
      },
    },
    [`&[data-view="${ChartViewEnum.BOTH}"]`]: {
      color: theme.palette.info.main,
      borderColor: theme.palette.info.main,
      backgroundColor: alpha(theme.palette.info.main, 0.16),

      "&:hover": {
        backgroundColor: alpha(theme.palette.info.main, 0.16),
      },
    },
    [`&[data-view="${ChartViewEnum.CONSENSUS}"]`]: {
      color: theme.palette.gold.dark,
      borderColor: theme.palette.gold.dark,
      backgroundColor: alpha(theme.palette.gold.main, 0.16),

      "&:hover": {
        backgroundColor: alpha(theme.palette.gold.main, 0.16),
      },
    },
  },
}));
